import { Box, makeStyles, Typography, useTheme } from '@material-ui/core'
import curvedDownArrowLeft from 'img/curvedDownArrowLeft.svg'
import curvedDownArrowRight from 'img/curvedDownArrowRight.svg'

export interface SquareButtonProps {
  size: string
  text: string
  textSize: 'normal' | 'small'
  active: boolean
  showArrow?: boolean
  arrowType?: string
}

export const CircleStep = ({
  size,
  text,
  textSize,
  active = false,
  showArrow = false,
  arrowType,
}: SquareButtonProps): JSX.Element => {
  const { palette } = useTheme()

  const useStyles = makeStyles(() => ({
    root: {
      height: size,
      width: size,
      backgroundColor: active ? palette.primary.main : palette.lightBlue,
      borderRadius: '50%',
      color: active ? 'white' : palette.primary.main,
      textAlign: 'center',
      padding: 2,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }))
  const classes = useStyles()

  return (
    <Box width={size}>
      <Box className={classes.root}>
        <Box>
          <Typography variant={textSize === 'normal' ? 'body1' : 'body2'}>
            <b>{text}</b>
          </Typography>
        </Box>
      </Box>
      {showArrow &&
        (arrowType === 'right' ? (
          <Box textAlign="right">
            <img src={curvedDownArrowRight} />
          </Box>
        ) : (
          <Box>
            <img src={curvedDownArrowLeft} />
          </Box>
        ))}
    </Box>
  )
}
